if (!customElements.get('squishpop-live-viewers')) {
  class SquishpopLiveViewers extends HTMLElement {
    connectedCallback() {
      this.valueElement = this.querySelector('[data-viewer-value]');
      if (
        !this.valueElement ||
        this.dataset.enabled !== 'true' ||
        window.matchMedia('(prefers-reduced-motion: reduce)').matches
      ) return;

      this.minimum = this.readNumber('min', 0);
      this.maximum = Math.max(this.minimum, this.readNumber('max', this.minimum));
      this.step = Math.max(1, this.readNumber('step', 1));
      this.interval = Math.max(2000, this.readNumber('interval', 6000));
      this.current = this.clamp(this.readNumber('current', this.minimum));
      this.valueElement.textContent = this.current.toLocaleString();
      this.timer = window.setInterval(() => this.advance(), this.interval);
    }

    disconnectedCallback() {
      if (this.timer) window.clearInterval(this.timer);
      this.timer = null;
    }

    readNumber(name, fallback) {
      const value = Number(this.dataset[name]);
      return Number.isFinite(value) ? value : fallback;
    }

    clamp(value) {
      return Math.min(this.maximum, Math.max(this.minimum, Math.round(value)));
    }

    advance() {
      const lower = Math.max(this.minimum, this.current - this.step);
      const upper = Math.min(this.maximum, this.current + this.step);
      let next = lower + Math.floor(Math.random() * (upper - lower + 1));
      if (upper > lower && next === this.current) next = next < upper ? next + 1 : next - 1;
      this.current = this.clamp(next);
      this.valueElement.textContent = this.current.toLocaleString();
      this.classList.remove('is-changing');
      void this.offsetWidth;
      this.classList.add('is-changing');
    }
  }

  customElements.define('squishpop-live-viewers', SquishpopLiveViewers);
}
